// Module
var code = "<!--<div class=\"flex-noshrink block-container\" ng-class=\"vm.block.config.classes\">-->\n<form-block ng-if=\"!!vm.formTemplate\" flex form-block=\"vm.block\" template=\"vm.formTemplate\"\n            on-change=\"vm.change()\"></form-block>\n<!--<div ng-if=\"!vm.formTemplate\">no no</div>-->\n<!--</div>-->";
// Exports
module.exports = code;